const red500Color = '#612020';

export default red500Color;
